<template>
  <div class="home"> 
    <div class="card">
   <div>
      <h2 class="title"> {{$t('new_password')}} </h2>
      <p class="or"><span></span></p>
      <div v-if="sent" class="alert alert-success" role="alert">
        {{$t('password_updated')}} <a href="/login"> {{$t('login')}} </a>
      </div>
      <div v-else>
          <div class="email-login">
            <label for="psw"><b>{{$t('password')}} <span class="required">*</span></b></label>
            <input type="password" placeholder="*******" name="psw" v-model="password" @keyup.enter="signUp" required>
          </div>
          <div class="email-login">
            <label for="new-password"><b>{{$t('new_password')}} <span class="required">*</span></b></label>
            <input type="password" placeholder="*******" name="new-password" v-model="repeat_password" @keyup.enter="signUp" required>
          </div>
          <button class="cta-btn" @click="resetPassword" :disabled="loading">{{loading === true ? 'Loading...' : $t('save')}}</button>
  
      </div>
    
      <a class="forget-pass" href="/login">{{$t('already_have_an_account')}}?</a>
   </div>
   
</div>
  </div>
</template>

<script>
import helper from '../helper';

export default {
  name: 'ResetPassword',
  components: {
  },
  data(){
    return {
        password : '',
        repeat_password : '',
        sent : false,
        loading : false
    }
  },
  mounted(){
    window.mixpanel.track("new_password");
    if(!this.$route.query.token) return this.$route.push('/500')
  },
  methods : {
    async resetPassword(){
        if(this.password == ''){
          window.vueOpener.open({
            message: this.$t('please_complete_all_required_fields'),
            type: 'warning',
            position : 'bottom'
          });
          return;
        }


        if(this.password != this.repeat_password){
           window.vueOpener.open({
            message: this.$t('unmatched_passwords'),
            type: 'warning',
            position : 'bottom'
          });
          return;
        }
        /* window.grecaptcha.ready(() => {
          this.loading = true
          window.grecaptcha.execute('6LetDZEmAAAAAEr9EdTVoDeg6-saEQYhXVSlrQhO', {action: 'submit'})
              .then( async (token) => {
                if(token){ */
                     try{
                      this.sent = false
                      this.loading = true
                      await helper.customPost(`${process.env.VUE_APP_API}/new-password`,
                      {
                        password : this.password, 
                        // token, 
                        reset_token : this.$route.query.token, 
                      })
                      this.loading = false
                      this.password = ''
                      this.repeat_password = ''
                      this.sent = true

                    }catch(error){
                      this.loading = false
                    }
                /* }
              })
              .catch(() => {
                this.loading = false
              })
        }) */
       
    },

  }
}
</script>

<style scoped>
body {
  background-color: rgb(228, 229, 247);
}
.social-login img {
  width: 24px;
}
a {
  text-decoration: none;
}

.card {
  font-family: var(--bs-body-font-family);
  
  width: 350px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3em;
  margin-bottom:3em;
  border-radius: 10px;
  background-color: #ffff;
  padding: 1.8rem;
  box-shadow: 2px 5px 20px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  font-weight: bold;
  margin: 0;
}
.subtitle {
  text-align: center;
  font-weight: bold;
}
.btn-text {
  margin: 0;
}

.social-login {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.google-btn {
  background: #fff;
  border: solid 2px rgb(245 239 239);
  border-radius: 8px;
  font-weight: bold;
  display: flex;
  padding: 10px 10px;
  flex: auto;
  align-items: center;
  gap: 5px;
  justify-content: center;
}
.fb-btn {
  background: #fff;
  border: solid 2px #004aad;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
}

.or {
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid rgb(245 239 239);
  line-height: 0.1em;
  margin: 25px 0;
}
.or span {
  background: #fff;
  padding: 0 10px;
}

.email-login {
  display: flex;
  flex-direction: column;
}
.email-login label {
  color: rgb(170 166 166);
}

input[type="text"],
input[type="password"] {
  padding: 15px 20px;
  margin-top: 8px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
}

.cta-btn {
  background-color: #004aad;
  color: white;
  padding: 18px 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 10px;
  border: none;
}

.forget-pass {
  text-align: center;
  display: block;
}

</style>
